<template>
    <DataTable
            v-redirect-if-no-permission:TYPES
            :url="api.ACTIONS.BANKS"
            :fieldsHiddenMain='["deleted_at"]'
            :fieldsHiddenAdd='["created_at","deleted_at","updated_at","id"]'
            :fieldsDisabledEdit='["created_at","deleted_at","updated_at","id"]'
            :fieldsExtraAdd="{name : 'v-text-field'}"
            :titles="titles"
            :add-rules="{name: [val => !!val || 'This field is required']}"
            title="Banks"/>
</template>

<script>
    import DataTable from "@/components/wasilni/DataTable";

    export default {
        name: "Banks",
        title: 'Banks',
        components: {DataTable},
        computed: {
            titles() {
                return {
                    "id": "#",
                    "name": "Name",
                    "created_at": "Created At",
                    "updated_at": "Updated At"
                }
            }
        }
    }
</script>

<style scoped>

</style>